var _desc, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Transaction-Pop-Income-2",
    transform: "translate(-313.000000, -441.000000)",
    fill: "#EEB200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(26.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy-2",
    transform: "translate(267.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,20 L26.6666667,14 L36,14 L36,30 L20,30 L20,20 L26.6666667,20 Z M22,22 L22,23.3333333 L24.6666667,23.3333333 L24.6666667,22 L22,22 Z M22,24.6666667 L22,26 L24.6666667,26 L24.6666667,24.6666667 L22,24.6666667 Z M28.6666667,23.3333333 L28.6666667,25.3333333 L30.6666667,25.3333333 L30.6666667,23.3333333 L28.6666667,23.3333333 Z M28.6666667,20 L28.6666667,22 L30.6666667,22 L30.6666667,20 L28.6666667,20 Z M28.6666667,16.6666667 L28.6666667,18.6666667 L30.6666667,18.6666667 L30.6666667,16.6666667 L28.6666667,16.6666667 Z M32,23.3333333 L32,25.3333333 L34,25.3333333 L34,23.3333333 L32,23.3333333 Z M32,20 L32,22 L34,22 L34,20 L32,20 Z M32,16.6666667 L32,18.6666667 L34,18.6666667 L34,16.6666667 L32,16.6666667 Z",
    id: "Shape"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.36c76bf57a80df5672f8f6b7465ae56f.svg";
export { ForwardRef as ReactComponent };